// Shared connection-filter tab definitions used by both MainPane (the
// Connections list strip) and AddConnectionSinglePage (the type chips).
//
// "Other" is intentionally a curated NOT-in-primary bucket — kinds with
// their own pill (case / account / business) live on those pills; every
// other connectable kind falls under Other. Tasks are commented out
// until the backend Task model is ready.

import type { EntityKind } from "./types";

export type ConnTab = "all" | "case" | "account" | "business" | "other";

export const CONN_TABS: Array<{ key: ConnTab; label: string }> = [
  { key: "all", label: "All" },
  { key: "case", label: "Cases" },
  { key: "account", label: "Accounts" },
  { key: "business", label: "Businesses" },
  // { key: "task", label: "Tasks" },  // Task model not yet implemented in backend.
  { key: "other", label: "Other" },
];

/** Kinds with a dedicated pill — anything not in this set falls into "Other". */
export const PRIMARY_TAB_KINDS: ReadonlyArray<EntityKind> = ["case", "account", "business"];

export function matchesTab(kind: EntityKind, tab: ConnTab): boolean {
  if (tab === "all") return true;
  if (tab === "other") return !PRIMARY_TAB_KINDS.includes(kind);
  return kind === tab;
}
